import { TextField } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl } from "../../../";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { LocalizedStringsMethods } from "react-localization";
//import InputMask from 'react-input-mask';
const InputMask = require('react-input-mask');

function MaskedTextControl(props: DynamicFormControl) {
    const [value, setValue] = useState(props.value ?? '');

    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    const handleChange = (event: any) => {
        const value = event.target.value as string;

        if (props.setState) {
            props.setState(value);
        }
        setValue(value);
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value ?? '');
        };
    }

    return (
        <InputMask value={value} onChange={handleChange} mask={props.mask ? props.mask : ""} maskPlaceholder=" " ele  disabled={props.disabled}>
            {() =>
                <TextField
                    type="text"
                    autoComplete={props.autoComplete}
                    autoFocus={props.autoFocus}
                    fullWidth={props.fullWidth}
                    id={props.id}
                    name={props.name}
                    placeholder={props.placeholder}
                    disabled={props.disabled}
                    required={props.required}
                    rows={props.rows}
                    maxRows={props.rowsMax}
                    size={props.size}
                    label={label}
                    key={label}
                />}
        </InputMask>
    )
}


export default MaskedTextControl;